import { execAdmin } from '@src/apis/reware/utils';

import type {
  PricingRule,
  PricingRuleInput,
  CreatePricingRuleExecVariables,
  CreatePricingRuleExecResponse,
} from './types';

export interface CreatePricingRuleArgs {
  partnerId: number;
  pricingType: string;
  rule: PricingRuleInput;
}

export const createPricingRule = async ({
  partnerId,
  pricingType,
  rule,
}: CreatePricingRuleArgs): Promise<PricingRule> => {
  const query = `
    mutation createPricingRule(
      $partnerId: Int!
      $pricingType: String!
      $rule: PricingRuleInput!
    ) {
      partner(id: $partnerId) {
        createPricingRule(
          pricingType: $pricingType
          rule: $rule
        ) {
          id
          position
          condition
          department
          category
          merchantCategory
          tag
          name
          secondaryTag
          secondaryName
          tertiaryTag
          tertiaryName
          discount
          sourceColumn
          upc
        }
      }
    }
  `;

  const data = await execAdmin<CreatePricingRuleExecVariables, CreatePricingRuleExecResponse>(
    query,
    { variables: { partnerId, pricingType, rule } }
  );

  return data.partner.createPricingRule;
};
